import { flowMax, SimpleUnchangedProps } from 'ad-hok'
import { addEffectOnMount } from 'ad-hok-utils'

import { addNotificationContext } from 'components/notifications'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import {
  getHasJoinedAppWaitlist,
  getTimesLaunchedForAppWaitlist,
  incrementTimesLaunchedforAppWaitlist,
  getHasShownRodeoButtonTutorial,
  recordHasJoinedAppWaitlist,
} from './appStorage'
import { APP_WAITLIST_URL } from './urls'

const PROMPT_TIMER_MS = 10000
const MAX_TIMES_SHOW_NOTIFICATION = 5

export const addAppWaitlistPrompt: SimpleUnchangedProps = flowMax(
  addNotificationContext,
  addTranslationHelpers,
  addEffectOnMount(({ showNotification, t }) => () => {
    if (getHasJoinedAppWaitlist()) {
      return
    }

    const timesLaunched = getTimesLaunchedForAppWaitlist()
    if (MAX_TIMES_SHOW_NOTIFICATION <= timesLaunched) {
      return
    }

    const timer = setInterval(() => {
      if (!getHasShownRodeoButtonTutorial()) {
        return
      }
      incrementTimesLaunchedforAppWaitlist()
      showNotification({
        text: t('menu.appWaitlistPrompt'),
        button: {
          title: t('menu.appWaitlist'),
          navigateTo: APP_WAITLIST_URL,
          external: true,
          onClick: () => {
            recordHasJoinedAppWaitlist()
          },
          onClickAnalyticsEvent: {
            options: {
              category: 'general',
              action: 'join_app_waitlist_from_notification',
            },
          },
        },
        style: 'bottom',
        sticky: true,
        onTimeOutAnalyticsEvent: {
          options: {
            category: 'general',
            action: 'join_app_waitlist_notification_time_out',
          },
        },
      })
      clearInterval(timer)
    }, PROMPT_TIMER_MS)
  })
)
